import { api } from "../api";
import {
  LOGIN_STEPS,
  ERROR_EMAIL_NOT_VERIFIED,
  ERROR_OTP_REQUIRED,
  LoginSubmitForm,
  SIGNUP_STEPS
} from "./auth";
import { backendErrors } from "@/forms/service/common";

export const premiumAnalyticsLoginFlow: LoginSubmitForm = async formData => {
  try {
    const {
      data: { data }
    } = await api.uas.loginPremiumAnalytics(formData);

    return { next: LOGIN_STEPS.REDIRECT_STEP, data };
  } catch ({ response }) {
    const { errors, data } = response.data;

    if (errors.code === ERROR_EMAIL_NOT_VERIFIED) {
      return {
        next: LOGIN_STEPS.VERIFY_STEP,
        data
      };
    }

    if (errors.code === ERROR_OTP_REQUIRED) {
      return {
        next: LOGIN_STEPS.ONE_TIME_PASSWORD_STEP,
        data
      };
    }

    const throttleDelay = parseInt(data && data.retryAfter) || null;

    throw { errors, data, throttleDelay };
  }
};

export const premiumAnalyticsPhoneLoginFlow: LoginSubmitForm = async formData => {
  try {
    const {
      data: { data }
    } = await api.uas.loginToPremiumAnalyticsByPhone(formData);

    return { next: LOGIN_STEPS.REDIRECT_STEP, data };
  } catch ({ response }) {
    const { errors, data } = response.data;

    if (errors.code === ERROR_EMAIL_NOT_VERIFIED) {
      return {
        next: LOGIN_STEPS.VERIFY_STEP,
        data
      };
    }

    if (errors.code === ERROR_OTP_REQUIRED) {
      return {
        next: LOGIN_STEPS.ONE_TIME_PASSWORD_STEP,
        data
      };
    }

    const throttleDelay = parseInt(data && data.retryAfter) || null;
    throw { errors, data, throttleDelay };
  }
};

const loginMethods: Record<string, any> = {
  EMAIL: premiumAnalyticsLoginFlow,
  PHONE: premiumAnalyticsPhoneLoginFlow
};

export const getPremiumLoginFlow = (methodName: string) => {
  return loginMethods[methodName] || null;
};

export const premiumAnalyticsDisplayEntities = {
  LOGIN_FORM: "LOGIN_FORM",
  SIGNUP_FORM: "SIGNUP_FORM"
};

export const premiumAnalyticsRegister = async (data: any) => {
  try {
    const { data: signupData } = await api.uas.registerPremiumAnalytics(data);
    return {
      next: SIGNUP_STEPS.THANK_YOU_STEP,
      data: signupData
    };
  } catch ({ response: { data: errors } }) {
    throw { errors: backendErrors(errors) };
  }
};
